import React from 'react';
import { MDBNavbar, MDBNavbarNav, 
  MDBCollapse, MDBNavItem, MDBNavLink, MDBContainer, 
  MDBRow, MDBCol, MDBNavbarBrand, MDBModal, MDBModalBody, 
  MDBModalHeader,
  MDBIcon } from 'mdbreact';
import { Link } from 'react-router-dom';
import bird from '../img/bird.png'
import pageConstruction from '../img/page-construction.json';
import Lottie from 'lottie-react-web';
import scrollDown from '../img/scrollDown.json'
import HamburgerMenu from 'react-hamburger-menu';
import NavbarSocials from './NavbarSocials';
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      modal: false,
      shop: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  toggleShop = () => this.setState({ shop: !this.state.shop })

  closeModal = () => this.setState({ modal: !this.state.modal }); 

  render() {
    const fontSize = {
      fontWeight: `900`,
      textTransform: `capitalize`
    }
    return (
      <div>
        <header>
            <>
              <MDBNavbar className="z-depth-0 p-lg-5 p-md-5 p-4" color="transparent" light expand="md" scrolling transparent>
                <MDBContainer className="px-0">
                  <MDBNavbarBrand href="/">
                    <strong style={{ fontWeight: `900` }} className="navbar-home menu-mobile-style text-capitalize h2-responsive black-text">
                      Home
                    </strong>
                    <span className="navbar-home-mobile ml-n1" style={{ fontSize: '25px'}}>
                      <MDBIcon className="grey-text" icon="home" />
                    </span>
                  </MDBNavbarBrand>
                  <HamburgerMenu
                    isOpen={this.state.modal}
                    menuClicked={this.onClick}
                    className="cursor-pointer-style mobile-bird"
                    width={25}
                    height={15}
                    strokeWidth={2}
                    rotate={0}
                    color='grey'
                    borderRadius={0}
                    style={{ fontSize: `30px` }}
                    animationDuration={0.5}
                />
                  <MDBCollapse isOpen={this.state.collapse} navbar>
                    <MDBNavbarNav className="p-2 align-items-center" left>
                      <MDBNavItem>
                        <MDBNavLink className="black-text px-5" to="/about">
                          <strong className="menu-mobile-style h2-responsive" style={fontSize}>About</strong>
                        </MDBNavLink>
                      </MDBNavItem>
                      <MDBNavItem>
                        <a className="black-text px-5 link" href="#shop" type="button" onClick={this.toggleShop}>
                          <strong className="menu-mobile-style h2-responsive" style={fontSize}>Shop</strong>
                        </a>
                      </MDBNavItem>
                      <MDBNavItem>
                        <MDBNavLink className="black-text px-5" to="/blogs">
                          <strong className="menu-mobile-style h2-responsive" style={fontSize}>Blog</strong>
                        </MDBNavLink>
                      </MDBNavItem>
                      <MDBNavItem>
                        <a className="black-text px-5 link" href="#search" type="button" onClick={this.props.onClick}>
                          <strong className="menu-mobile-style h2-responsive" style={fontSize}>Search</strong>
                        </a>
                      </MDBNavItem>
                      <MDBNavItem>
                        <MDBNavLink className="black-text px-5" to="/advocacy">
                          <strong className="menu-mobile-style h2-responsive" style={fontSize}>Advocacy</strong>
                        </MDBNavLink>
                      </MDBNavItem>
                    </MDBNavbarNav>
                  </MDBCollapse>
                </MDBContainer>
              </MDBNavbar>
            </>
            <main style={{ display: this.props.show ? 'none' : 'inline' }} className="br-navbar-container">
              <MDBContainer>
                <div className="mobile-bird-hide">
                  <MDBRow>
                    <MDBCol className="text-center align-self-center" lg="6">
                      <h1 className="hero-text black-text text-uppercase font-weight-bold">
                        Minimuni
                      </h1>
                      {this.props.slogan && <p className="lead black-text">
                        {this.props.slogan}
                      </p>}
                      {this.props.slogan && <div className="d-flex justify-content-center"><Lottie width="10%" options={{ animationData: scrollDown }}/> </div>}
                      {this.props.page && <h2 style={{ letterSpacing: '0.5rem' }} className="menu-mobile-style p-2 display-4 black-text">
                        {this.props.page}
                      </h2>}
                    </MDBCol>
                    <MDBCol lg="6">
                      <img className="bird-responsive" src={bird} alt=""/>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="mobile-bird">
                  <div className="d-flex flex-column text-center justify-content-center mt-5">
                    <img style={{ alignSelf: 'center' }} src={bird} className="w-50 h-100" alt=""/>
                    <h1 className="h1-reponsive black-text text-center font-weight-bold text-uppercase">Minimuni</h1>
                    {this.props.slogan && <p className="lead black-text">
                      {this.props.slogan}
                    </p>}
                    {this.props.slogan && <div className="d-flex justify-content-center"><Lottie width="10%" options={{ animationData: scrollDown }}/> </div>}
                    {this.props.page && <h2 style={{ margin: '2%', fontSize: '40px', letterSpacing: '0.5rem' }} className="menu-mobile-style p-2 h2-responsive black-text">
                      {this.props.page}
                    </h2>}
                  </div>
                </div>
              </MDBContainer>
            </main>
        </header>

        {/* REDIRECT TO SHOP STARTS */}

        <MDBModal isOpen={this.state.shop} centered>
        <MDBModalHeader toggle={this.toggleShop} style={{ border: 0 }}/>
            <MDBModalBody>
            <div className="p-5">
                <div className="text-center">
                <div>
                    <Lottie
                    options={{
                        animationData: pageConstruction
                    }}
                    />
                </div>
                <div className="mt-4">
                    <p className="font-weight-bold">
                      We'll be leaving the Blog part of Minimuni, we'll now go to the E-Commerce part of Minimuni.
                    </p>
                </div>
                <div>
                    <a href="https://theminimuni.com/pages/shop.html" className="newsletter-subscription-button z-depth-1">I understand</a>
                </div>
                </div>
            </div>
            </MDBModalBody>
        </MDBModal>

        {/* REDIRECT TO SHOP END */}
        
        <MDBModal toggle={this.closeModal} centered size="lg" isOpen={this.state.modal}>
            <MDBModalBody style={{ padding: "10%", background: '#EBFDFC' }}>
                <MDBContainer className="d-flex flex-column text-center mt-4 justify-content-center">
                  <div className="d-flex mb-4" style={{ justifyContent: 'flex-end', marginTop: '-10%' }}>
                    <MDBIcon icon="times" onClick={this.closeModal} />
                  </div>
                  <div className="text-center">
                    <h3 className="h3-responsive p-2 mb-3 text-capitalize font-weight-bold">
                      <Link className="menu-mobile-style black-text" to="/">Home</Link>
                    </h3>
                    <h3 className="h3-responsive p-2 my-3 text-capitalize font-weight-bold">
                      <Link className="menu-mobile-style black-text" to="/about">About us</Link>
                    </h3>
                    <h3 className="h3-responsive p-2 my-3 text-capitalize font-weight-bold">
                      <a className="menu-mobile-style black-text" href="#shop" onClick={()=>{
                          this.setState({ modal: false, shop: true })
                        }}>Shop</a>
                    </h3>
                    <h3 className="h3-responsive p-2 my-3 text-capitalize font-weight-bold">
                      <Link className="menu-mobile-style black-text" to="/blogs">Blog</Link>
                    </h3>
                    <h3 className="h3-responsive p-2 my-3 text-capitalize font-weight-bold">
                      <Link className="black-text px-5 menu-mobile-style link" to="/search">Search</Link>
                    </h3>
                    <h3 className="h3-responsive p-2 my-3 text-capitalize font-weight-bold">
                      <Link className="menu-mobile-style black-text" to="/advocacy">Advocacy</Link>
                    </h3>
                    <div className="d-flex justify-content-around text-center mt-5 mb-4">
                      <NavbarSocials/>
                    </div>
                  </div>
                </MDBContainer>
            </MDBModalBody>
        </MDBModal>

      </div>
    );
  }
}

export default Navbar;